import { ThemeProvider } from '@mui/material/styles';
import { getTheme } from '@parsys/frontend_library';
import { ErrorBoundary } from '@sentry/react';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';

import ListActionBar from './ListActionBar';
import ErrorFallback from 'FRONTEND/components/ErrorFallback';
import { THEME_APP_NAME } from 'FRONTEND/utils/constants';

import './index.css';

export default (element, store) => {
  let title;
  try {
    title = JSON.parse(element.dataset.title);
  } catch {
    title = element.dataset.title;
  }

  const root = createRoot(element);
  const theme = getTheme({ app: THEME_APP_NAME, branding: window.branding });
  root.render(
    <ErrorBoundary fallback={<ErrorFallback />}>
      <Provider store={store}>
        <ThemeProvider theme={theme}>
          <ListActionBar
            title={title}
            workflows={element.dataset.workflows ? JSON.parse(element.dataset.workflows) : []}
            createLabel={element.dataset.createLabel}
            upload={element.dataset.upload && JSON.parse(element.dataset.upload)}
            search={element.dataset.search && JSON.parse(element.dataset.search)}
            initialFilters={element.dataset.filters && JSON.parse(element.dataset.filters)}
          />
        </ThemeProvider>
      </Provider>
    </ErrorBoundary>,
  );

  return () => {
    root.unmount();
  };
};
